import React, {FC, PropsWithChildren, createContext, useMemo, useState} from 'react';

import Footer from 'ui/components/Footer';

interface FooterContextProps {
    setFooter: (value: boolean) => void;
}

export const FooterContext = createContext<FooterContextProps>({
    setFooter: () => {},
});

export const FooterContextProvider: FC<PropsWithChildren> = ({children}) => {
    const [footer, setFooter] = useState(false);
    const value = useMemo(() => ({setFooter}), []);
    return (
        <FooterContext.Provider value={value}>
            {children}
            {footer && <Footer />}
        </FooterContext.Provider>
    );
};
